import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "a59a3090-136c-4472-9f83-3024e80deb63",
    content: "Answer A",
    options: { image: `${config.ASSETS_URL}/04/24/task/task-2-answer-a.svg` },
  },
  {
    id: "098b6013-9840-44cc-8a9b-6d104665e6e7",
    content: "Answer B",
    options: { image: `${config.ASSETS_URL}/04/24/task/task-2-answer-b.svg` },
  },
  {
    id: "b30e8e80-c639-4f33-ba5a-32785632a4ea",
    content: "Answer C",
    options: { image: `${config.ASSETS_URL}/04/24/task/task-2-answer-c.svg` },
  },
  {
    id: "9a46c918-ba5c-41b3-ab88-cc11bb5c466c",
    content: "Answer D",
    options: { image: `${config.ASSETS_URL}/04/24/task/task-2-answer-d.svg` },
  },
];

export const task: Task = {
  id: "e00e178a-e887-46b2-a46f-2acc78b70f62",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["b30e8e80-c639-4f33-ba5a-32785632a4ea"],
};
